export default "__VITE_ASSET__7zoT_NU0__"